module.exports = __webpack_public_path__ + "media/images/drop-call-e91f9ad8890aeda415ecdd4bf3ccd073.svg";